import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MfaService {
  private apiUrl = environment.API_URL
  constructor(private http: HttpClient) { }

  enableMfa(mfaSessionId: string): Observable<{ key: string, qrCodeData: string }> {
    return this.http.post<any>(`${this.apiUrl}mfa/enable/${mfaSessionId}`, {});
  }

  verifySetup(code: string, mfaSessionId: string): Observable<{ success: boolean, recoveryCodes?: string[] }> {
    return this.http.post<any>(`${this.apiUrl}mfa/verify-setup`, { code, mfaSessionId });
  }

  resetUserMfa(userId: any) {
    return this.http.post(`${this.apiUrl}user/ResetMfa/${userId}`, {});
  }

  ResetUserMfaWithPassword(userId: any, password: string) {
    return this.http.post(`${this.apiUrl}mfa/ResetUserMfa`, { password: password });
  }
}
